import CompraDocumentoFiscalInput from './CompraDocumentoFiscalInput';

export default CompraDocumentoFiscalInput;
